module.exports = __webpack_public_path__ + "static/media/wf.a10487a6.svg";